<script setup lang="ts">
import { ref } from 'vue'
import { IonModal, IonPage } from '@ionic/vue'
import ClearIcon from '@/components/svg/ClearIcon.vue'
import type { PreviousUniverse } from '@/services/universe'

interface Props {
  isOpen: boolean
  previousUniverse?: PreviousUniverse | null
  nextUniverse?: PreviousUniverse | null
  presentingElement?: HTMLElement | null
}

const props = defineProps<Props>()
const emits = defineEmits<Emits>()

interface Emits {
  (e: 'select'): void
  (e: 'close'): void
}

const modal = ref()
const page = ref()

function handleCloseModal() {
  emits('close')
}
</script>

<template>
  <ion-page ref="page">
    <ion-modal
      ref="modal" mode="ios" :is-open="isOpen" :presenting-element="presentingElement"
      @ion-modal-did-dismiss="handleCloseModal"
    >
      <ion-header>
        <ion-toolbar>
          <ion-title>Sekai Storyline</ion-title>
          <ion-buttons slot="end">
            <ion-button color="light" @click="handleCloseModal">
              <clear-icon />
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <div class="p-4">
          <div>
            <div v-if="previousUniverse?.items.length">
              <div class="title">
                Previous Episodes
              </div>
              <div v-for="item in previousUniverse.items" :key="item.universeId" class="item">
                <img class="img" :src="item.gifUrl" alt="">
                <div class="flex-1">
                  <div>{{ item.highlightText }}</div>
                  <div>by {{ item.creatorUserName }} · {{ item.viewCount }} views</div>
                </div>
                <div class="view-btn" @click="emits('select')">
                  View
                </div>
              </div>
            </div>
          </div>
          <div class="main-btn" @click="emits('select')">
            Make Your Own Next Episode
          </div>
        </div>
      </ion-content>
    </ion-modal>
  </ion-page>
</template>

<style scoped>
ion-toolbar {
  --background: #292929;
}

ion-searchbar {
  --border-radius: 100px;
}

ion-content {
  --background: #292929;
}

.title {
  color: #FAFAFA;
  font-family: Manrope;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  /* 144.444% */
}

.item {
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.item .img {
  width: 45px;
  height: 60px;
  border-radius: 4px;
}

.view-btn {
  color: var(--white-trans-white-100, #FFF);
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  /* 142.857% */
  padding: 4px 8px;
}

.main-btn {
  display: flex;
  height: 44px;
  padding: 4px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: var(--Color-Core-actionB, #000);
  font-family: Manrope;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  /* 133.333% */
  border-radius: 100px;
  background: var(--Color-Core-primaryB, #00F8FF);
  user-select: none;
  cursor: pointer;
  margin-top: 18px;
  position: fixed;
  bottom: 32px;
  width: calc(100vw - 32px);
}
</style>
